import Component from '@cell/cell-core/component/component';
import './filter-mobile.scss';

class FilterMobile extends Component {
  constructor() {
    super();

    this.elements = {
      content: this.querySelector('.FilterMobile__Content'),
      valueList: this.querySelector('.FilterMobile__ValueList'),
      scrollInfo: this.querySelector('.ScrollInfo'),
    };

    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleShowContentClick = this.handleShowContentClick.bind(this);
    this.handleFilterRemove = this.handleFilterRemove.bind(this);
    this.handleFilterSubmitClick = this.handleFilterSubmitClick.bind(this);
    this.handleValueListScroll = this.handleValueListScroll.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.back', this.handleBackClick);
    this.on('c-button.click.show-content', this.handleShowContentClick);
    this.on('c-button.click.remove', this.handleFilterRemove);
    this.on('c-button.click.submit', this.handleFilterSubmitClick);
  }

  handleBackClick() {
    this.elements.content.classList.remove('FilterMobile__Content--Active');
  }

  handleShowContentClick() {
    this.elements.content.classList.add('FilterMobile__Content--Active');

    const checkScrollability = (element) => {
      // Content element is not (nor not enough) scrollable so there is no need to display a scroll info.
      if (element.clientHeight >= element.scrollHeight) {
        return;
      }

      // Use `addEventListener` instead of `on` to we can remove the listener later on.
      // TODO: This should work with `on` as well in the future.
      element.addEventListener('scroll', this.handleValueListScroll);

      setTimeout(() => {
        this.elements.scrollInfo?.show();
      }, 500);
    };

    checkScrollability(this.elements.valueList);
  }

  handleFilterRemove() {
    const url = this.querySelector('.FilterMobile__Actions').getAttribute('data-url-to-remove');

    this.emit('remove', { url });
  }

  handleFilterSubmitClick() {
    this.elements.content.classList.remove('FilterMobile__Content--Active');
  }

  handleValueListScroll() {
    this.elements.valueList.removeEventListener('scroll', this.handleValueListScroll);

    this.elements.scrollInfo?.hide();
  }
}

customElements.define('filter-mobile', FilterMobile);
